module.exports = __webpack_public_path__ + "assets/video/ingela.554dba8.mp4";


//////////////////
// WEBPACK FOOTER
// ./src/assets/video/ingela.mp4
// module id = 1070
// module chunks = 0